{
	"title": "Service unavailable (500)",
	"description": "Try to refresh this page or check your internet connection. If this error persists, please report it as a bug, so that we can take action.",
	"primaryButtonTitle": "Refresh page",
	"secondaryButtonTitle": "Copy error log",
	"errorLogCopiedMessage": "Error log copied",
	"traceparentLabel": "Traceparent"
}
